import React from 'react';
import { getTranslateByScope } from '../../i18n';
import { BIKE_CLUSTER } from '../../constants';
import { Clusters } from './Clusters';

const translate = getTranslateByScope('app.clusters.bikeClusters');

export const BikeClusters = (props) => (
  <Clusters title={translate('title')} clusterType={BIKE_CLUSTER} {...props} />
);
